<template>
  <WsMain>
    <WsCrud
      :modelName="$store.state.model[modelName].modelName"
      :label="$store.state.model[modelName].label"
      :fields="$store.state.model[modelName].fields"
      :liveSearching="true"
      :showFields="showFields"
    ></WsCrud>
  </WsMain>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "山葵仔職業技能",
    };
  },
  data: () => ({
    modelName: "wasa_hr_skill",
    showFields: ["id", "wasa", "hr_skill", "reach_at"],
  }),
};
</script>